import config from "@/config";
import Vue from "vue";
import Router from "vue-router";
import { getToken } from "../../../util";

Vue.use(Router);

// const ssoUrl =
//   process.env.NODE_ENV === "development"
//     ? config.ssoUrl.dev
//     : config.ssoUrl.pro;

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: () => import("@/components/page/Index.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  const token = getToken();
  console.log(token);
  if (token) {
    window.location.href = `${localStorage.getItem(
      "indexSales"
    )}/home.htm#/manage`;
    return;
  } else {
    //let url = "https://fedlogin.jnj.com/as/authorization.oauth2?client_id=isalesplus-qa-jjmc&client_secret=L5KbsodohcgfGf4JCUp0ZEIM4AxcYcsO3CGPRqy9y08NZ9PCNiOPMwrgp5pQTGO1&response_type=code&redirect_uri=https://isalesplus-qa.jjmc.cn/getSSOAccesstoken&nonce=" + RondomPass(10)
    let url = "https://fedlogin.jnj.com/as/authorization.oauth2?client_id=isalesplus-pro-jjmc&client_secret=gBAZXXQJSszIKw9Mo8wCb7sw4XN3DrZPfeJAPH3DMOBDtL23gbFj9OcCOBpRTIiN&response_type=code&redirect_uri=https://isalesplus-pro.jjmc.cn/getSSOAccesstoken&nonce=" + RondomPass(10)
    // let url =
    //   "https://sso.kenvue.com/as/authorization.oauth2?client_id=ch_constore_qa&client_secret=QIBwu09mcGMik82fwTwNbHof2TVBaFiSd5v0Yc5MF0GMGQPPDCkwFJrlH4IPtbSD&response_type=code&redirect_uri=" +
    //   encodeURIComponent(ssoUrl) +
    //   "&nonce=" +
    //   RondomPass(10);
    // let url = "https://sso.kenvue.com/as/authorization.oauth2?client_id=ch_constore_prod&client_secret=RIzpAv3D2QLDIZaqLvc4OcgXOKbEcEotyQXPBmDVrPr9RdW7FWMtIIo9BRNI089G&response_type=code&redirect_uri="+encodeURIComponent(ssoUrl)
    //   + "&nonce=" + RondomPass(10)
    // let url = config.developURL;
    window.location.href = url;
    return;
  }
  next();
});

function RondomPass(number) {
  let arr = new Array();
  let arr1 = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9");
  let nonceStr = "";
  for (var i = 0; i < number; i++) {
    let n = Math.floor(Math.random() * 10);
    arr[i] = arr1[n];
    nonceStr += arr1[n];
  }
  console.log("222：", nonceStr);
  return nonceStr;
}

export default router;



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js